var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('contact-information',{attrs:{"userInfo":_vm.user,"email":_vm.user.email,"isLoading":_vm.loading},on:{"prev":_vm.toIndex,"next":_vm.editUser}})
}
var staticRenderFns = []

export { render, staticRenderFns }